import { fetchJSON } from '@bonnet/next/fetch';

const smsSubscribeServices = async (data) => {
    const response = await fetchJSON('/cars-for-sale/consumer-id', {
        body: {
            email: data?.email,
            brand: data?.brand || 'AT',
            firstName: data?.firstName,
            lastName: data?.lastName,
            phone_number: data?.destinationNumber,
            zip: data?.userZip,
        },
        method: 'POST',
        circuitBreaker: {
            id: 'consumerId',
            timeout: 5000,
            resetTimeout: 300000,
            fallback: {},
        },
    });

    fetchJSON('/cars-for-sale/sms-subscribe', {
        body: {
            firstName: data?.firstName,
            lastName: data?.lastName,
            destinationNumber: data?.destinationNumber,
            title: data?.title,
            listingId: data?.listingId,
            consumerId: response?.consumerId,
            brand: data?.brand,
            makeCode: data?.makeCode,
            modelCode: data?.modelCode,
            mileage: data?.mileage,
            year: data?.year,
            listingType: data?.listingType,
            zip: data?.listingZip,
        },
        method: 'POST',
    });
};

export default (data = {}) => (smsSubscribeServices(data));
